module.exports = __webpack_public_path__ + "static/media/display-4.a5ab10e5.png";